export default "__VITE_ASSET__e032041f__"